// script.js (box index.html) ~sdg
'use strict'
console.time('LoadTime')
import * as THREE from 'three'
// Styles
import './normalize.css'
import './style.css'

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const group = new THREE.Group()
scene.add(group)

/**
 * Axes Helper
 */
//const axesHelper = new THREE.AxesHelper(2)
//scene.add(axesHelper)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Debug lil-gui
 */
import * as dat from 'lil-gui'
const gui = new dat.GUI({ width: 200 })
gui.close()
gui.hide()

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
/*
 * Objects
 */
import { MeshBasicMaterial } from 'three'
const textureLoader = new THREE.TextureLoader()
// Flower
const flowerTexture = textureLoader.load('./textures/pictures/flower.jpg')
const flowerMaterial = new THREE.MeshBasicMaterial({
  map: flowerTexture
})
const flower = new THREE.Mesh( new THREE.BoxGeometry(1, 1, 1), flowerMaterial)
flower.position.set(-1, 1.5, -2)

// Inside
const insideTexture = textureLoader.load('./textures/pictures/flower.jpg')
const insideMaterial = new MeshBasicMaterial({
  map: insideTexture,
})
const inside = new THREE.Mesh(new THREE.BoxGeometry(0.4, 0.4, 0.4), insideMaterial)
inside.position.set(0.5, -0.5, 0)

// Hummer
const hummerTexture = textureLoader.load('./textures/pictures/hummer.jpg')
const hummerMaterial = new MeshBasicMaterial({
  map: hummerTexture,
  transparent: true,
  opacity: 0.75
})
const hummer = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), hummerMaterial)
hummer.position.set(0.5, -0.5, 0)
hummer.rotation.x = Math.PI * 0.125

// Mine Craft
const mineCraftTexture = textureLoader.load('./textures/pictures/minecraft.png')
const mineCraftMaterial = new MeshBasicMaterial({
  map: mineCraftTexture
})
mineCraftTexture.generateMipmaps = false
mineCraftTexture.magFilter = THREE.NearestFilter
const mineCraft = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), mineCraftMaterial)
mineCraft.position.set(1, 2, -3)

// MatCap
const matCapTexture = textureLoader.load('./textures/matcaps/8.png')
const matCapMaterial = new THREE.MeshMatcapMaterial({
  matcap: matCapTexture,
})
const matCap = new THREE.Mesh(new THREE.BoxGeometry(0.75, 0.75, 0.75), matCapMaterial)
matCap.position.set(-0.5, 0, -1.5)

scene.add(flower, inside, hummer, mineCraft, matCap)

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 4
camera.lookAt(mineCraft)
scene.add(camera)

// Controls
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
const controls = new OrbitControls(camera, canvas)
controls.enableRotate = false
controls.maxDistance = 10
controls.minDistance = 1
controls.enabled = true

/**
 * Animate
 */
const clock = new THREE.Clock()
const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()

  // Update controls
  controls.update()

  // Update objects
  flower.rotation.x = 0.25 * elapsedTime
  flower.rotation.y = 0.25 * elapsedTime

  hummer.rotation.y = 0.25 * elapsedTime

  inside.rotation.x = - elapsedTime
  inside.rotation.y = - elapsedTime

  mineCraft.rotation.y = - 0.25 * elapsedTime
  mineCraft.rotation.x = - 0.25 * elapsedTime

  matCap.rotation.x = 0.3 * elapsedTime
  matCap.rotation.y = 0.3 * elapsedTime

  // Render
  renderer.render(scene, camera)
  window.requestAnimationFrame(animate)
}
animate()
console.timeEnd('LoadTime')
// EOF script.js (box index.html) ~sdg